import { ReactNode, createContext, useContext, useState } from "react";

interface MyPageContextType {
  resvStat: number;
  setResvStat: (resvStat: number) => void;
}

export const MyPageContext = createContext<MyPageContextType | undefined>(
  undefined
);

interface IJoinProvider {
  children: ReactNode;
}

export const MyPageProvider = ({ children }: IJoinProvider) => {
  const [resvStat, setResvStat] = useState(1);

  return (
    <MyPageContext.Provider
      value={{
        resvStat,
        setResvStat,
      }}
    >
      {children}
    </MyPageContext.Provider>
  );
};

export const useMypageContext = (): MyPageContextType => {
  const context = useContext(MyPageContext);
  if (!context) {
    throw new Error("useAuthContext GridProvider 내에서만 사용해야 합니다.");
  }

  return context;
};
